import { useTranslation } from 'react-i18next'

import { useManageTemplateDefault, TemplateLike } from './useManageTemplateDefault'

type UseSetDefaultTemplateProps = {
  setDefaultTemplate: (templateId: string) => Promise<unknown>
  onSet: VoidFunction
}

export const useSetDefaultTemplate = <T extends TemplateLike>({
  setDefaultTemplate,
  onSet
}: UseSetDefaultTemplateProps) => {
  const { t } = useTranslation()

  const { target, setTarget, isLoading, handleAction, success, closeSuccess } = useManageTemplateDefault<T>({
    action: setDefaultTemplate,
    onSuccess: onSet,
    errorToastMessage: t('toast.templates.setDefaultError')
  })

  return {
    templateToSetDefault: target,
    setTemplateToSetDefault: setTarget,
    isSettingDefault: isLoading,
    handleSetDefault: handleAction,
    setDefaultSuccess: success,
    closeSetDefaultSuccess: closeSuccess
  }
}
